import {
  AutoCompleteSearch,
  FacultyCard,
  LoadingListEntityProfile,
} from "Explore/Components";
import { Empty } from "antd";
import styles from "./InstitutionScholars.module.scss";
import { getSuggestSearchAuthors } from "Explore/Services/Author";
import useExploreInfo from "Hooks/useExploreInfo";
import { Grid } from "@mui/material";
import SortSelect, { SORT_TYPE } from "Explore/Components/SortSelect";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import { useState } from "react";
import useInfinityPagination from "Hooks/useInfinityPagination";
import { getInstitutionScholarsByID } from "Explore/Services/Institution";
import InfinityPagination from "Explore/Components/Pagination/InfinityPagination";

const InstitutionScholars = ({
  institution_id,
  // data,
  // setFacultySearchFilter,
  // facultySearchFilter,
  // handleClearSearch,
  selectedKeywords,
  selectedKeywordsQueue,
  sliderValue,
  // showLoginSection,
}) => {
  const { institution_id: institutionIdentifier } = useExploreInfo();
  const targetInstitutionId = institution_id || institutionIdentifier;
  const keywordsForFiltering =
    selectedKeywordsQueue && !selectedKeywords.length > 0
      ? [...selectedKeywords, ...selectedKeywordsQueue.flat(Infinity)]
      : selectedKeywords;
  const [query, setQuery] = useState("");
  const [facultySearchFilter, setFacultySearchFilter] = useState({
    orderBy: "h_index",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 20,
  });
  const [showLoginSection, setShowLoginSection] = useState(false);

  const { data, currentMaxPage, hasNextPage, isLoading } =
    useInfinityPagination({
      fetchFunction: getInstitutionScholarsByID,
      resultKey: "authors",
      page: pagination.page,
      filter: {
        id: targetInstitutionId,
        query,
        keywords: selectedKeywords,
        startYear: sliderValue[0],
        order_by: facultySearchFilter.orderBy,
        endYear: sliderValue[1],
      },
      rowsPerPage: pagination.rowsPerPage,
      setPagination,
      errCallback: (e) => {
        if (e?.response?.status === 401) {
          setShowLoginSection(true);
        }
      },
    });

  return (
    <div className={styles["institution-scholars"]}>
      <div className={styles["search-scholar-section"]}>
        <div className={styles["search-container"]}>
          <AutoCompleteSearch
            placeholder={"Search a Scholar"}
            functionSearch={(params, callback) =>
              getSuggestSearchAuthors(params, callback, {
                institutionId: targetInstitutionId,
              })
            }
            filters={query}
            setFilters={setQuery}
            entity="query"
            hideFilterSelectedTags
          />
          <button
            className={styles["clear-search-button"]}
            onClick={() => setQuery("")}
            disabled={!query}
          >
            Clear
          </button>
        </div>
        <SortSelect
          sortData={{ orderBy: facultySearchFilter.orderBy }}
          setSortData={(e) =>
            setFacultySearchFilter({ ...facultySearchFilter, ...e })
          }
          sortType={SORT_TYPE.FACULTY_LIST}
          filter={{
            query: facultySearchFilter.query,
            keywordQuery: keywordsForFiltering,
          }}
          loading={isLoading}
        />
      </div>

      <LoadingListEntityProfile
        isLoading={isLoading}
        component={
          (data[pagination.page - 1] || []).length > 0 ? (
            <Grid container>
              {(data[pagination.page - 1] || []).map((item, index) => {
                return (
                  <Grid item md={12} key={index}>
                    <FacultyCard data={item} />
                  </Grid>
                );
              })}
            </Grid>
          ) : showLoginSection ? (
            <LoginRequiredSection />
          ) : (
            <Empty description="No Scholar Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
      <InfinityPagination
        style={{ marginTop: "20px" }}
        currentMaxPage={currentMaxPage}
        pagination={pagination}
        setPagination={setPagination}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        sizeChanger
      />
    </div>
  );
};

export default InstitutionScholars;
